module.exports = __webpack_public_path__ + "img/20191119163212360截图20191119162554638.ba913b94.jpg";